module.exports = __webpack_public_path__ + "static/media/ImgCamera.e83f0fc7.svg";